import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IDeleteShipments } from "../interfaces/IDeleteShipment";
import { deleteShipment } from "../services/http-service/deleteShipments";

export const useDeleteShipment = ({
  deleteShipmentData,
  enabled,
}: {
  deleteShipmentData?: IDeleteShipments;
  enabled?: boolean;
}) => {
  const {
    isLoading: loadingDeleteShipment,
    isFetching: fetchingDeleteShipment,
    isError: errorFetchingDeleteShipment,
    data: deleteShipmentResponse,
    error: errorDeleteShipmentResponse,
    refetch: refetchDeleteShipment,
  } = useQuery({
    queryKey: ["deleteShipment"],
    queryFn: async () => await deleteShipment(deleteShipmentData),
    enabled: enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: false,
    staleTime: 0,
    cacheTime: 0,
  });
  const fetchDeleteShipmentError = (errorDeleteShipmentResponse as AxiosError)?.response?.data;

  return {
    loadingDeleteShipment,
    fetchingDeleteShipment,
    errorFetchingDeleteShipment,
    deleteShipmentResponse,
    fetchDeleteShipmentError,
    refetchDeleteShipment,
  };
};
